<template>
  <swiper
    :options="swiperOption"
    class="my-swiper"
    v-if="banner && banner.length > 0"
  >
    <template>
      <swiper-slide v-for="(item, index) in banner" :key="index">
        <a :href="item.url" v-if="item.url"
          ><img :src="item.covers" v-load="'oTopicBanner'"
        /></a>
        <img v-else :src="item.covers" v-load="'oExhibitorBanner'" />
      </swiper-slide>
    </template>
    <!-- <template v-else>
      <swiper-slide><img src="@assets/img/ex_default_banner.jpg" /></swiper-slide>
    </template> -->
    <div class="swiper-pagination" v-if="banner.length>1" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
import gql from "graphql-tag";
var bannerGql = gql`
  query($exhibitionId: Guid!, $position: String!) {
    banners(exhibitionId: $exhibitionId, position: $position) {
      covers
      id
      url
      position
      showIndex
    }
  }
`;
export default {
  name: "swiper-banner",
  // props: ['data'],
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 4000,
        },
      },
      Systemconfig: "",
      banner: [],
    };
  },
  components: { Swiper, SwiperSlide },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
    }),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$apollo.addSmartQuery("banners", {
        query: bannerGql,
        variables: {
          exhibitionId: this.exhibitionId,
          position: "show.page.exhibitors.en",
        },
        result({ data, loading, networkStatus }) {
          if (data && data.banners) {
            data.banners.sort((a,b)=>{return a.showIndex - b.showIndex});
            this.banner = data.banners;
          }
          console.log({ data, loading, networkStatus });
        }, // 错误处理
        error(error) {
          console.error(error, "error错误处理");
        },
      });
    },
  },
};
</script>
 
<style scoped lang="scss">
.my-swiper {
  // height: 2.3rem;
}
.swiper-container {
  font-size: 0;
}
img {
  width: 100%;
  height: 100%;
  display: block;
  // object-fit: cover;
}
</style> 